import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useMutation } from '@apollo/react-hooks';

import AuthWelcome from './AuthWelcome';

import bufflLogo from '../../assets/img/buffl.svg';

import './LoginRegistration.css';

import { RESET_PASSWORD } from '../../graphql/Auth';

export default props => {
  const { match, history } = props;

  const emptyFields = { password: '', repeatPassword: '' };
  const ERROR_MESSAGES = {
    INVALID_TOKEN: 'Link to reset password has expired',
    PASSWORD_NOT_MATCH: 'Passwords do not match',
    RESET_FAILED: 'Password reset request failed',
    FILL_ALL_FIELDS: 'Please fill in all fields'
  };

  const [error, setError] = useState(null);
  const [fields, setFields] = useState(emptyFields);

  const [passwordChecks, setPasswordChecks] = useState({
    length: false,
    uppercase: false,
    number: false
  });
  const isPasswordEntered = fields.password.length > 0;
  const handlePasswordValidation = password => {
    setPasswordChecks({
      length: password.length >= 8,
      uppercase: /[A-Z]/.test(password),
      number: /\d/.test(password)
    });
  };
  const matchedConditions = Object.values(passwordChecks).filter(Boolean)
    .length;

  const passwordScore = matchedConditions * 33.33;
  const getProgressColor = () => {
    if (matchedConditions === 1) return 'red';
    if (matchedConditions === 2) return 'orange';
    if (matchedConditions === 3) return 'green';
    return 'transparent';
  };

  const [resetPassword, { loading }] = useMutation(RESET_PASSWORD, {
    onCompleted: response => {
      if (
        response &&
        response.resetPassword &&
        response.resetPassword.done &&
        !(response.resetPassword.errors && response.resetPassword.errors.length)
      ) {
        history.push({
          pathname: '/auth/login',
          search: 'passwordReset=success'
        });
      } else {
        setError(ERROR_MESSAGES.INVALID_TOKEN);
      }
    },
    onError: () => setError(ERROR_MESSAGES.RESET_FAILED)
  });

  const handleSubmit = async e => {
    e.preventDefault();
    setError(null);
    if (Object.values(fields).some(field => !field || field === ''))
      return setError(ERROR_MESSAGES.FILL_ALL_FIELDS);
    if (fields.password !== fields.repeatPassword) {
      return setError(ERROR_MESSAGES.PASSWORD_NOT_MATCH);
    }
    if (Object.values(fields).some(field => field.length < 8)) {
      return setError('Password must be at least 8 characters long');
    }

    if (match && match.params && match.params.token) {
      resetPassword({
        variables: { password: fields.password, token: match.params.token }
      });
    } else {
      setError(ERROR_MESSAGES.INVALID_TOKEN);
    }

    return true;
  };

  return (
    <div className="right-container">
      <AuthWelcome />
      <div className="form-container">
        <form onSubmit={handleSubmit}>
          <img className="buffl-logo" src={bufflLogo} alt="Buffl Logo" />
          <div className="form-container-title">Reset password</div>
          <input
            type="password"
            className="password-input"
            value={fields.password}
            onChange={e => {
              const { value } = e.currentTarget;
              setFields({ ...fields, password: value });
              handlePasswordValidation(value);
            }}
            placeholder="New password"
          />
          {isPasswordEntered && (
            <>
              <div className="password-progress">
                <div
                  className="password-progress-bar"
                  style={{
                    width: `${passwordScore}%`,
                    backgroundColor: getProgressColor(),
                    transition: 'all 0.3s ease'
                  }}
                />
              </div>

              <ul className="password-checklist">
                <li
                  style={{ color: passwordChecks.length ? 'green' : '#797575' }}
                >
                  At least 8 characters
                </li>
                <li
                  style={{
                    color: passwordChecks.uppercase ? 'green' : '#797575'
                  }}
                >
                  One uppercase letter
                </li>
                <li
                  style={{ color: passwordChecks.number ? 'green' : '#797575' }}
                >
                  One number
                </li>
              </ul>
            </>
          )}
          <input
            type="password"
            className="password-input"
            value={fields.repeatPassword}
            onChange={e =>
              setFields({
                ...fields,
                ...{ repeatPassword: e.currentTarget.value }
              })
            }
            placeholder="Repeat new password"
          />
          {error && !loading && <div className="error-message">{error}</div>}
          {!loading ? (
            <button type="submit" className="button">
              Reset password
            </button>
          ) : (
            <div className="button-loading">
              <div />
              <div />
              <div />
              <div />
            </div>
          )}
          <span className="link">
            <Link to="/auth/register">Don&#39;t have an account? Sign up</Link>
          </span>
        </form>
      </div>
    </div>
  );
};
